/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EvaluationReportAiResponseDto } from '../../models/evaluation-report-ai-response-dto';
import { RequestEvaluationReportAiDto } from '../../models/request-evaluation-report-ai-dto';

export interface DocumentAiControllerEvaluationReportAi$Params {
  ticketId: string;
  centerId: string;
  type: string;
      body: RequestEvaluationReportAiDto
}

export function documentAiControllerEvaluationReportAi(http: HttpClient, rootUrl: string, params: DocumentAiControllerEvaluationReportAi$Params, context?: HttpContext): Observable<StrictHttpResponse<EvaluationReportAiResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiControllerEvaluationReportAi.PATH, 'post');
  if (params) {
    rb.path('ticketId', params.ticketId, {});
    rb.query('centerId', params.centerId, {});
    rb.query('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EvaluationReportAiResponseDto>;
    })
  );
}

documentAiControllerEvaluationReportAi.PATH = '/api/document-ai/evaluation-report-ai/{ticketId}';
